import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import { FaCamera } from 'react-icons/fa';
// import src1 from '../../../assets/images/heatmap.jpg';
// import src2 from '../../../assets/images/heatmap2.jpg';
import { useEffect } from 'react';
import { GetAllCamera, GetOneCamera } from 'api/sentinelAPI';
import NoDataImg from '../../../assets/images/noCamera.jpg';
import { useSelector } from 'react-redux';
// import { ca } from 'date-fns/locale';

// const imgURLs = {
//   camera1: src1,
//   camera2: src2
// };

export default function ShelfView() {
  const [url, setUrl] = useState(false);
  const [active, setActive] = useState('');
  const [cameraList, setCameraList] = useState(false);
  const date = useSelector((state) => state.customization.currentDate);

  const fetchAllCamera = async () => {
    const data = await GetAllCamera();
    if (data) {
      setCameraList(data);
    }
  };

  const fetchOneCamera = async (name) => {
    const body = { date: new Date(date).toLocaleDateString('en-GB').replace(/\//g, '-'), camera_device_name: name };
    const response = await GetOneCamera(body);
    if (response) {
      const imgUrl = URL.createObjectURL(response);
      setUrl(imgUrl);
    } else {
      setUrl('iugrgiihiu');
    }
  };

  useEffect(() => {
    fetchAllCamera();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ height: '433px', margin: '20px' }}>
      <Grid className="h-full" container spacing={4}>
        <Grid className="h-full overflow-y-auto scrollbar pr-4" item md={3}>
          {cameraList ? (
            cameraList.map((camera, index) => {
              // console.log('Each Camera', camera);
              return (
                <Paper
                  key={index}
                  elevation={4}
                  className="flex items-center mb-4 cursor-pointer p-5"
                  onClick={() => {
                    fetchOneCamera(camera.device_name);
                    setActive(camera.device_name);
                  }}
                  style={{
                    backgroundColor: active === camera.device_name ? 'black' : 'white',
                    color: active === camera.device_name ? 'white' : 'black',
                    fontWeight: 'bolder'
                  }}
                >
                  <div
                    style={{
                      height: '30px',
                      width: '30px',
                      borderRadius: '50%',
                      background: 'black',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '8px'
                    }}
                  >
                    {' '}
                    <FaCamera />{' '}
                  </div>
                  <h6>{camera.device_name}</h6>
                </Paper>
              );
            })
          ) : (
            <div className="Font-bold text-lg">No Camera Found</div>
          )}
        </Grid>

        <Grid item md={9}>
          {cameraList ? (
            <>
              {!url ? (
                <div className="w-full h-full flex justify-center place-items-center text-center">
                  <span className="font-bold text-xl">Please select one camera from the list to show its location in your system</span>
                </div>
              ) : (
                <img src={url} alt="no image found" style={{ height: '400px', width: '100%' }} />
                // <div className="w-full h-full flex justify-center place-items-center text-center">
                //   <span className="font-bold text-xl">{url}</span>
                // </div>
              )}
            </>
          ) : (
            <img src={NoDataImg} alt="img" style={{ height: '400px', width: '100%' }} />
          )}
        </Grid>
      </Grid>
    </div>
  );
}
